export const sessionInitTrue = '1'
export const sessionInitFalse = '0'
